import api from './api';

export const agendaPublicService = {
    getAgendas: async (params = {}) => {
        try {
            const response = await api.get('/agenda', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data'
            };
        }
    },

    getAgendaBySlug: async (slug) => {
        try {
            const response = await api.get(`/agenda/${slug}`);
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Agenda tidak ditemukan'
            };
        }
    },
};

export default agendaPublicService;